import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home/index.vue' // 首页
// import Pay from '../views/pay/index.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index'),
    },
    {
        path: '/books',
        name: 'books',
        component: () => import('@/views/Home/books-detail'),
    },

]

const router = new VueRouter({
    routes
})

export default router